<template>
  <div style="justify-content: center">
    <el-button
      type="info"
      style="background-color: #008a2c"
      icon="el-icon-back"
      circle
      @click="goBack"
    ></el-button>
    <div
      style="
        width: 100%;
        text-align: center;
        font-size: 25px;
        font-weight: bold;
      "
    >供应商录入</div>
    <div class="form" v-loading="loading">
      <el-form ref="formData" label-width="100px" :model="formData" :rules="rules">
        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="企业名称：" label-width="150px" prop="suppName">
              <el-input v-model="formData.suppName" @blur="getSuppName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业简称：" label-width="120px" prop="f1">
              <el-input v-model="formData.f1" maxlength="5" show-word-limit placeholder="至多五个字" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="公司地址：" label-width="150px" prop="addess">
              <el-input v-model="formData.addess" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人代表：" label-width="120px" prop="legalPerson">
              <el-input v-model="formData.legalPerson" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="联系人：" label-width="150px" prop="contactUser">
              <el-input v-model="formData.contactUser" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电话：" label-width="120px" prop="phone">
              <el-input v-model="formData.phone" />
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-button
              type="success"
              plain
              size="small"
              style="height:40px"
              @click="getAuthCode()"
              :disabled="!isSend"
            >{{sendMsg}}</el-button>
          </el-col>
          <el-col :span="5">
            <el-form-item label="验证码：" label-width="130px">
              <el-input v-model="authCode" placeholder="请输入验证码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="是否上市公司：" label-width="150px" prop="isIpo">
              <el-select
                v-model="formData.isIpo"
                placeholder="请选择"
                style="width:100%"
                @change="checkIpo1"
              >
                <el-option label="是" value="是" />
                <el-option label="否" value="否" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-show="checkIpo" label="公司上市日期：" label-width="120px" prop="ipoDate">
              <el-date-picker
                v-model="formData.ipoDate"
                placeholder="选择日期"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6" style="margin-top: 12px">
          <el-col :span="12">
            <el-form-item label="企业性质：" label-width="150px" prop="enterpriseNature">
              <el-select
                v-model="formData.enterpriseNature"
                clearable
                filterable
                placeholder="请选择"
                style="width:100%"
                @change="checkIpo1"
              >
                <el-option
                  v-for="item in supplierNatureData"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业：" label-width="120px" prop="industry">
              <el-select
                v-model="formData.industry"
                clearable
                filterable
                style="width:100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in supplierTypeData"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="公司成立日期：" label-width="150px" prop="fundDate">
              <el-date-picker
                v-model="formData.fundDate"
                placeholder="选择日期"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册资金(万)：" label-width="120px" prop="regCapital">
              <el-input v-model="formData.regCapital" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" label-width="150px" prop="uscCode">
              <el-input v-model="formData.uscCode" @blur="getUscCode" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司网址：" label-width="120px" prop="webUrl">
              <el-input v-model="formData.webUrl" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="邮编：" label-width="150px" prop="zip">
              <el-input v-model="formData.zip" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号：" label-width="120px" prop="bankAccount">
              <el-input v-model="formData.bankAccount" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="开户行：" label-width="150px" prop="bankName">
              <el-input v-model="formData.bankName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="24">
            <el-form-item label="经营范围：" label-width="150px" prop="businessScope">
              <el-input
                v-model="formData.businessScope"
                :autosize="{ minRows: 2, maxRows: 5 }"
                maxlength="60"
                placeholder="请输入内容"
                :rows="2"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="24">
            <el-form-item label="备注说明：" label-width="150px" prop="memo">
              <el-input
                v-model="formData.memo"
                :autosize="{ minRows: 2, maxRows: 5 }"
                maxlength="60"
                placeholder="请输入内容"
                :rows="2"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="6">
          <el-col :span="12">
            <el-form-item label="营业执照:" label-width="150px" prop="certPhoto">
              <el-upload
                ref="upload1"
                :action="uploadPath"
                :before-remove="removeCertPhoto"
                :before-upload="beforeAvatarUpload"
                :data="uploadCertPhoto"
                :headers="headers"
                :limit="1"
                list-type="picture-card"
                name="Fdata"
                :on-exceed="OnExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove1"
                :on-success="handleAvatarSuccess"
              >
                <i class="el-icon-plus"></i>
              </el-upload>

              <div>
                <span v-show="showSpan1" style="color: rgb(7, 143, 68)">下方为原营业执照</span>
              </div>
              <span v-for="item in echoCertPhotoList" :key="item.name" class="avatar">
                <el-image
                  :key="item.name"
                  class="avatar"
                  :preview-src-list="[item.url]"
                  :src="item.url"
                  style="
                  width: 150px;
                  height: 150px;
                  margin: 0px 2px;
                  margin-top: 5px;
                  border: 1px solid #eee;
                "
                />
              </span>
              <el-dialog append-to-body :visible.sync="dialogVisible">
                <img alt :src="dialogImageUrl" width="100%" />
              </el-dialog>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="税务登记证:" label-width="120px" prop="taxCert">
              <el-upload
                ref="upload2"
                :action="uploadPath"
                :before-remove="removetaxCert"
                :before-upload="beforeAvatarUpload2"
                :data="uploadTaxCert"
                :headers="headers"
                :limit="1"
                list-type="picture-card"
                name="Fdata"
                :on-exceed="OnExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove2"
                :on-success="handleAvatarSuccess"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div>
                <span v-show="showSpan2" style="color: rgb(7, 143, 68)">下方为原税务登记证</span>
              </div>
              <span v-for="item in echoTaxCertList" :key="item.name" class="avatar">
                <el-image
                  :key="item.name"
                  class="avatar"
                  :preview-src-list="[item.url]"
                  :src="item.url"
                  style="
                  width: 150px;
                  height: 150px;
                  margin: 0px 2px;
                  margin-top: 5px;
                  border: 1px solid #eee;
                "
                />
              </span>
              <el-dialog append-to-body :visible.sync="dialogVisible">
                <img alt :src="dialogImageUrl" width="100%" />
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item style="align-items: center; text-align: center">
              <el-button class="submitClass" @click="submitForm">提交</el-button>
              <el-button class="colseClass" @click="goBack">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Message } from "element-ui";
import { uploadPath, fileAcquisition } from "@/config/net.config";
import {
  addSupplier,
  getSuppName,
  getUscCode,
  getSysDict,
  getAuthCode,
  checkAuthCode
} from "@/api/supplier.js";
export default {
  name: "AddInvoice",
  data() {
    //校验手机号
    const validatePhone = (rule, value, callback) => {
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    //校验统一社会信用代码
    const validateUscCode = (rule, value, callback) => {
      const regExp = /^[a-zA-Z0-9]{6,18}$/;
      if (!regExp.test(value) && value != "") {
        callback(new Error("最少6~18位且可包含数字与字母！"));
      } else if (
        this.UscCodeTotal == "1" &&
        this.title == "供应商录入" &&
        this.isUscCodeEdit == true
      ) {
        callback(new Error("该统一社会信用代码已存在！"));
      } else if (
        this.UscCodeTotal == "1" &&
        this.title == "编辑供应商" &&
        this.isUscCodeEdit == true
      ) {
        callback(new Error("该统一社会信用代码已存在!"));
      } else {
        callback();
      }
    };
    //校验企业网址
    const acceptUrlValidator = (rule, value, callBack) => {
      let url = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/[\]@!$&'*+,;=.]+$/;
      if (value) {
        if (!url.test(value)) {
          callBack("请输入正确的企业地址");
        } else {
          callBack();
        }
      } else {
        callBack();
      }
    };
    //校验邮编
    const validateEmail = (rule, value, callBack) => {
      let url = /^[0-9]{6}$/;
      if (value) {
        if (!url.test(value)) {
          callBack("请输入正确的邮编(六位数字)");
        } else {
          callBack();
        }
      } else {
        callBack();
      }
    };
    //校验企业注册资金
    const validateRegCapital = (rule, value, callBack) => {
      //^[1-9][0-9]{0,7}$/
      let url = /^[1-9][0-9]{0,5}$/;
      if (value) {
        if (!url.test(value)) {
          callBack("请输入正确的注册资金");
        } else {
          callBack();
        }
      } else {
        callBack();
      }
    };
    //校验银行账号
    const validateBankAccount = (rule, value, callBack) => {
      let url = /^[0-9]{6,18}$/;
      if (value) {
        if (!url.test(value)) {
          callBack("请输入正确的银行账号(至少6位数字，至多18位！)");
        } else {
          callBack();
        }
      } else {
        callBack();
      }
    };
    //校验是否上传营业执照
    (rule, value, callback) => {
      var arr = Object.keys(this.formData.certPhoto);
      if (arr.length < 1) {
        //我控制了FileList 长度代表文件个数
        callback(new Error("请上传文件"));
      } else {
        callback();
      }
    };
    //校验是否上传税务登记证
    (rule, value, callback) => {
      var arr = Object.keys(this.formData.taxCert);
      if (arr.length < 1) {
        //我控制了FileList 长度代表文件个数
        callback(new Error("请上传文件"));
      } else {
        callback();
      }
    };
    //校验企业名称
    const valiSupplierTotal = (rule, value, callback) => {
      if (
        this.supplierTotal == "1" &&
        this.title == "供应商录入" &&
        this.isSuppNameEdit == true
      ) {
        callback(new Error("该名称已存在"));
      } else if (
        this.supplierTotal == "1" &&
        this.title == "编辑供应商" &&
        this.isSuppNameEdit == true
      ) {
        callback(new Error("该名称已存在"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        memo: [{ max: 60, message: "最大输入个数为60" }],
        legalPerson: [{ max: 15, message: "最大输入个数为15" }],
        suppName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          { validator: valiSupplierTotal, trigger: ["bule", "change"] },
          { max: 30, message: "最大输入个数为30" }
        ],
        f1: [
          { required: true, message: "请输入企业简称", trigger: "blur" },
          { max: 5, message: "企业简称最多五个字" }
        ],

        regCapital: [
          // { required: true, message: '请输入注册资金', trigger: 'blur' },
          { validator: validateRegCapital, trigger: ["bule", "change"] }
        ],
        webUrl: [
          // { required: true, message: '请输入企业网址', trigger: 'blur' },
          { validator: acceptUrlValidator, trigger: ["bule", "change"] }
        ],
        businessScope: [
          // { required: true, message: '请输入经营范围', trigger: 'blur' },
          { max: 600, message: "最大输入个数为600" }
        ],
        zip: [{ validator: validateEmail, trigger: ["bule", "change"] }],
        bankAccount: [
          // { required: true, message: '请输入银行账号', trigger: 'blur' },
          { validator: validateBankAccount, trigger: ["bule", "change"] }
        ],
        bankName: [
          // { required: true, message: '请输入开户行', trigger: 'blur' },
          { max: 60, message: "最大输入个数为60" }
        ],
        enterpriseNature: [
          // {
          //   required: true,
          //   message: '请选择',
          //   trigger: 'change',
          //   value: true,
          // },
        ],

        isIpo: [
          // {
          //   required: true,
          //   message: '请选择',
          //   trigger: 'change',
          //   value: true,
          // },
        ],
        industry: [
          // {
          //   required: true,
          //   message: '请选择',
          //   trigger: 'change',
          //   value: true,
          // },
        ],
        fundDate: [
          // {
          //   required: true,
          //   message: '请选择日期',
          //   trigger: 'blur',
          // },
        ],
        uscCode: [
          // { required: true, message: '请输入社会信用代码', trigger: 'blur' },
          { validator: validateUscCode, trigger: "change" }
        ],
        addess: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
          { max: 150, message: "最大输入个数为150" }
        ],
        contactUser: [
          // { required: true, message: '请输入联系人', trigger: 'blur' },
          { max: 30, message: "最大输入个数为30" }
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: validatePhone, trigger: "change" }
        ],
        certPhoto: [],
        taxCert: [
          // {
          //   required: true,
          //   validator: valiTaxCertFile,
          //   trigger: 'blur',
          //   message: '请上传税务登记证',
          // },
        ]
      },
      supplierTypeData: [],
      supplierNatureData: [],
      formData: {
        suppName: "", //公司名称
        industry: "", //所属行业
        fundDate: "", //公司成立日期
        isIpo: "", //是否是上市公司
        ipoDate: "", //上市日期
        uscCode: "", //社会信用代码
        regCapital: "", //注册资金
        addess: "", //公司地址
        contactUser: "", //联系人
        phone: "", //联系方式
        memo: "", //备注
        certPhoto: {}, //营业执照
        taxCert: {}, //税务登记证
        legalPerson: "", //法人代表
        enterpriseNature: "", //企业性质
        webUrl: "", //公司网址
        businessScope: "", //经营范围
        zip: "", //邮编
        bankAccount: "", //银行账号
        bankName: "", //开户行
        f1: "" //企业简称
      },
      uploadCertPhoto: {
        uploadUrl: "",
        packageName: "/img",
        templateUrl: " ",
        queueLimit: 10,
        fileTypes: ["*"],
        limitSize: 2
      },
      uploadTaxCert: {
        markTaxCert: "TaxCert",
        uploadUrl: "",
        packageName: "/img",
        templateUrl: " ",
        queueLimit: 10,
        fileTypes: ["*"],
        limitSize: 2
      },
      headers: {
        appkey: "XKES"
      },
      showSpan1: false, //显示文件回显提示
      showSpan2: false, //显示文件回显提示
      fileList: [], //上传的文件
      echoCertPhotoList: [], //编辑里回显营业执照
      echoTaxCertList: [], //编辑里回显税务登记证
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      submitLoading: false,
      checkIpo: false,
      certPhotoBeforedeletefile: {}, //获取上次照片的file供退出时删除
      taxCertBeforedeletefile: {}, //获取上次照片的file供退出时删除
      certPhotoFileList: [],
      taxCertFileList: [],
      srcList: [],
      title: "",
      dialogFormVisible: false,
      list: [],
      markCertPhoto: "", //分辨营业执照和税务登记证
      supplierTotal: "", //同名企业个数
      UscCodeTotal: "", //相同
      oldformData: {}, //来接收到编辑传来的row
      isSuppNameEdit: false, //编辑是否修改了企业名称
      isUscCodeEdit: false, //编辑是否修改了统一社会信用代码
      dialogImageUrl: "",
      dialogVisible: false,
      loading: false,
      isSend: true,
      sendMsg: "获取验证码",
      totalTime: 60, //一般是60
      timer: "", //定时器
      authCode: "",
      authCodeKey: ""
    };
  },
  mounted() {
    this.getcontractType();
    this.getcontractNature();
  },
  methods: {
    //获取验证码功能
    async getAuthCode() {
      if (!this.formData.phone) {
        Message.error("请填写手机号后获取验证码！");
      } else if (/^1(3|4|5|6|7|8)\d{9}$/.test(this.formData.phone) == false) {
        Message.error("请填写正确的手机号后获取验证码！");
      } else {
        this.isSend = false;
        this.sendMsg = this.totalTime + "s后重新发送";
        let data = await getAuthCode(this.formData.phone);
        if (data != null && data != undefined && data.msg == "repeated") {
          this.$message({
            message: "提示:该手机号一分钟内已经申请过，请一分钟后重试!",
            type: "warning"
          });
        }else if (data != null && data != undefined ) {
          sessionStorage.setItem("xzztcToken", data.data.fwdtService);
          this.authCodeKey = data.msg;
        }
        this.timer = setInterval(() => {
          this.totalTime--;
          this.sendMsg = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            clearInterval(this.timer);
            this.sendMsg = "重新发送验证码";
            this.totalTime = 60;
            this.isSend = true;
          }
        }, 1000);
      }
    },
    async getcontractType() {
      const res = await getSysDict("SUPPLIER_TYPE");
      console.log(res);
      let dictData = [];
      res.data.map(item => {
        let dict = {
          value: item.dictcode,
          label: item.dictname,
          id: item.id
        };
        dictData.push(dict);
      });
      this.supplierTypeData = dictData;
    },
    async getcontractNature() {
      const res = await getSysDict("SUPPLIER_NATURE");
      console.log(res);
      let dictData = [];
      res.data.map(item => {
        let dict = {
          value: item.dictcode,
          label: item.dictname,
          id: item.id
        };
        dictData.push(dict);
      });
      this.supplierNatureData = dictData;
    },
    removetaxCert() {
      this.isRemoveCertPhoto = true;
    },
    removeCertPhoto() {
      this.isRemoveCertPhoto = true;
    },
    //获取企业名称
    async getSuppName() {
      this.supplierTotal = "";
      //新增的情况
      if (this.oldformData.suppName != this.formData.suppName) {
        this.isSuppNameEdit = true;
        if (this.formData.suppName == "") {
          //空字符去查的情况
          const suppName = "不存在";
          const { total } = await getSuppName(suppName);
          this.supplierTotal = total;
        } else {
          //输入值去查的情况
          const { total } = await getSuppName(this.formData.suppName);
          this.supplierTotal = total;
        }
      }
    },
    //获取统一社会信用代码
    async getUscCode() {
      this.UscCodeTotal = "";
      if (this.oldformData.uscCode != this.formData.uscCode) {
        this.isUscCodeEdit = true;
        if (this.formData.uscCode == "") {
          const uscCode = "不存在";
          const { total } = await getUscCode(uscCode);
          this.UscCodeTotal = total;
        } else {
          const { total } = await getUscCode(this.formData.uscCode);
          this.UscCodeTotal = total;
        }
      } else {
        this.isUscCodeEdit = false;
        const { total } = await getUscCode(this.formData.uscCode);
        this.UscCodeTotal = total;
      }
    },
    //时间转化
    dateFormat(row, column) {
      let date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    //上传个数多于1时
    OnExceed() {
      this.$message({
        message: "提示:只能上传一张照片，如需修改请删除原有照片!",
        type: "warning"
      });
    },
    //是否是上市公司
    checkIpo1() {
      if (this.formData.isIpo == "是") {
        this.checkIpo = true;
      } else {
        this.checkIpo = false;
      }
    },
    //查看上传文件
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //营业执照上传前
    beforeAvatarUpload(file) {
      //标志为营业执照
      this.markCertPhoto = "CertPhoto";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        Message({
          message: "文件大小不能超过 10MB!",
          type: "warning"
        });
        return false;
      }
      if (
        file.name.substring(file.name.lastIndexOf(".")) !== ".jpg" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".png" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".gif" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".bmp" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".jpeg"
      ) {
        Message({
          message: "仅支持上传jpg、png、gif、bmp、jpeg图片格式！",
          type: "warning"
        });
        return false;
      }
    },
    //税务登记证上传前
    beforeAvatarUpload2(file) {
      //标志为税务登记证
      this.markCertPhoto = "taxCert";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        Message({
          message: "文件大小不能超过 10MB!",
          type: "warning"
        });
        return false;
      }
      if (
        file.name.substring(file.name.lastIndexOf(".")) !== ".jpg" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".png" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".gif" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".bmp" &&
        file.name.substring(file.name.lastIndexOf(".")) !== ".jpeg"
      ) {
        Message({
          message: "仅支持上传jpg、png、gif、bmp、jpeg图片格式！",
          type: "warning"
        });
        return false;
      }
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log("res", res);
      this.beforedeletefile = file;
      if (this.markCertPhoto == "CertPhoto") {
        this.srcList = [];
        this.certPhotoFileList = [];
        //保存file供退出时删除照片
        this.certPhotoBeforedeletefile = file;
        this.srcList.push(this.fileAcquisition + res.object.url);
        this.certPhotoFileList.push({
          name: res.object.originalName,
          type: res.object.type,
          originalUrl: res.object.url,
          url: this.fileAcquisition + res.object.url
        });
        //span提示
        this.showSpan1 = false;
        this.echoCertPhotoList = [];
        this.formData.certPhoto = this.certPhotoFileList;
        this.markCertPhoto = "CertPhoneed";
      } else if (this.markCertPhoto == "taxCert") {
        this.taxCertBeforedeletefile = file;
        this.srcList = [];
        this.taxCertFileList = [];
        this.srcList.push(this.fileAcquisition + res.object.url);
        this.taxCertFileList.push({
          name: res.object.originalName,
          type: res.object.type,
          originalUrl: res.object.url,
          url: this.fileAcquisition + res.object.url
        });
        this.showSpan2 = false;
        this.echoTaxCertList = [];
        this.formData.taxCert = this.taxCertFileList;
      }
    },
    //删除文件
    handleRemove1(file) {
      let indexa = "";
      this.certPhotoFileList.forEach((item, index) => {
        if (item.url == file.url) {
          console.log("url:", item.url, file.url);
          indexa = index;
        }
      });
      this.certPhotoFileList.splice(indexa, 1);
      this.formData.certPhoto = this.certPhotoFileList;
      this.$refs.upload1.clearFiles();
    },
    handleRemove2(file) {
      let indexa = "";
      this.taxCertFileList.forEach((item, index) => {
        if (item.url == file.url) {
          indexa = index;
        }
      });
      this.taxCertFileList.splice(indexa, 1);
      this.$refs.upload2.clearFiles();
      this.formData.taxCert = this.taxCertFileList;
    },
    close() {
      this.handleRemove1(this.certPhotoBeforedeletefile);
      this.handleRemove2(this.taxCertBeforedeletefile);
      this.formData = {
        suppName: "", //公司名称
        industry: "", //所属行业
        fundDate: "", //公司成立日期
        isIpo: "", //是否是上市公司
        ipoDate: "", //上市日期
        uscCode: "", //社会信用代码
        regCapital: "", //注册资金
        addess: "", //公司地址
        contactUser: "", //联系人
        phone: "", //联系方式
        memo: "", //备注
        certPhoto: "", //营业执照
        taxCert: "", //税务登记证
        legalPerson: "", //法人代表
        enterpriseNature: "", //企业性质
        webUrl: "", //公司网址
        businessScope: "", //经营范围
        zip: "", //邮编
        bankAccount: "", //银行账号
        bankName: "" //开户行
      };
      this.UscCodeTotal = "";
      this.supplierTotal = "";
      this.srcList = [];
      this.fileList = [];
      this.certPhotoFileList = [];
      this.taxCertFileList = [];
      this.formData.certPhoto = "";
      this.formData.taxCert = "";
      this.echoCertPhotoList = [];
      this.echoTaxCertList = [];
      this.taxCertBeforedeletefile = {};
      this.certPhotoBeforedeletefile = {};
      this.dialogFormVisible = false;
      this.$refs.formData.resetFields();
      clearInterval(this.timer);
      this.sendMsg = "获取验证码";
      this.totalTime = 60;
      this.isSend = true;
      this.authCode = "";
    },
    submitForm() {
      var that = this;
      this.$refs["formData"].validate(async valid => {
        console.log("formData", this.formData);

        this.getSuppName();
        if (valid) {
          this.loading = true;
          let data = await checkAuthCode(this.authCodeKey, this.authCode);
          if (data.msgCode !== 0) {
            this.$message({
              message: "验证码错误！",
              type: "error"
            });
            this.loading = false;
            return;
          }
          this.formData.certPhoto = JSON.stringify(this.formData.certPhoto);
          this.formData.taxCert = JSON.stringify(this.formData.taxCert);
          await addSupplier(this.formData).then(response => {
            if (response.msgCode == 0) {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.markCertPhoto = "";
              this.submitLoading = false;
              this.dialogFormVisible = false;
              this.isSuppNameEdit = false;
              this.isUscCodeEdit = false;
              this.oldformData = {};
              this.$confirm(
                "您的资料已经提交成功，我们尽快与您电话联系核对信息，期待与贵司的合作！",
                "系统提示",
                {
                  confirmButtonText: "返回主页",
                  cancelButtonText: "继续预约",
                  type: "success",
                  center: true,
                  showClose: false,
                  callback: (action, instance) => {
                    console.log(action);
                    console.log(instance);
                    // 返回主页
                    if (action == "confirm") {
                      that.$router.push("/serviceHome");
                    }
                    // 继续反馈
                    // if (action == "cancel") {
                    // }
                  },
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  cancelButtonClass: "cancelButtonClass",
                  confirmButtonClass: "confirmButtonClass"
                }
              )
                .then(() => {
                  this.close();
                })
                .catch(() => {});
              this.close();
              this.loading = false;
            } else {
              this.$message({
                message: "添加失败",
                type: "error"
              });
              this.submitLoading = false;
              this.dialogFormVisible = false;
              this.loading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.close();
      this.$router.push("/serviceHome");
    }
  }
};
</script>

<style scoped>
.vab-tree-border {
  height: 200px;
  padding: 10px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 20px;
}
.box {
  display: block;
}
label {
  width: 150px;
}
.form {
  margin-left: 5%;
  border: 1px solid #dddddd;
  margin-top: 30px;
  padding: 20px;
  margin-right: 5%;
}
.submitClass,
.submitClass:focus {
  background-color: #008a2c;
  border-color: #008a2c;
  color: #fff;
}
.submitClass:hover {
  background: #85ce61;
  border-color: #85ce61;
  color: #fff;
}
</style>
